import { Component, EventEmitter, Input, Output, Signal, Type } from '@angular/core';
import { CommonModule, NgComponentOutlet } from '@angular/common';
import { IAbstractView, IBaseStrategy, ILanguageObject } from '@core/interfaces';
import { Schedule, Store as StoreModel } from '@core/models';
import { StoresListPresenter } from './stores-list.presenter';
import {
	IStoreSelectedEvent,
	IStoreStatus,
	IStoresListCallback,
	IStoresListComponent,
	IStoresListPresenter,
	IStoresListStrategyDomain,
} from './interfaces';
import { StoreDeliveryCodeEnum } from './enums';
import { StoreScheduleRange } from '../../domain';

@Component({
	selector: 'app-stores-list',
	templateUrl: './stores-list.component.html',
	styleUrls: ['./stores-list.component.scss'],
	imports: [CommonModule, NgComponentOutlet],
	providers: [StoresListPresenter],
	standalone: true,
})
export class StoresListComponent
	extends IAbstractView<IStoresListPresenter>
	implements IStoresListComponent
{
	private _storesWithDistance: StoreModel[] | null = null;
	private _storeInDelivery: StoreModel[] | null = null;
	private _orderType: string | null = 'Pickup';

	@Input() set storesWithDistance(value: StoreModel[] | null) {
		this._storesWithDistance = value;
		this.presenter.setStoresWithDistance(value);
	}
	get storesWithDistance(): StoreModel[] | null {
		return this._storesWithDistance;
	}

	@Input() set storeInDelivery(value: StoreModel[] | null) {
		this._storeInDelivery = value;
		this.presenter.setStoreInDelivery(value);
	}
	get storeInDelivery(): StoreModel[] | null {
		return this._storeInDelivery;
	}

	@Input() set orderType(value: string | null) {
		this._orderType = value;
		this.presenter.setOrderType(value);
	}
	get orderType(): string | null {
		return this._orderType;
	}

	@Output() storeSelected = new EventEmitter<IStoreSelectedEvent>();

	translations: ILanguageObject = this.presenter.translations;
	readonly selectedComponent: Signal<Type<IStoresListStrategyDomain> | null> =
		this.presenter.selectedComponent;
	readonly currentStores: Signal<StoreModel[]> = this.presenter.currentStores;
	readonly strategy: IBaseStrategy<IStoresListCallback> = this.presenter.strategy;

	constructor(presenter: StoresListPresenter) {
		super(presenter);
	}

	getRangeTimeByDay(
		store: StoreModel,
		code: StoreDeliveryCodeEnum
	): StoreScheduleRange | null {
		return this.presenter.getRangeTimeByDay(store, code);
	}

	getStoreStatus(horarios: Schedule[]): IStoreStatus {
		return this.presenter.getStoreStatus(horarios);
	}

	getStoreScheduleTime(
		store: StoreModel,
		code: StoreDeliveryCodeEnum,
		isAvailable: boolean
	): string {
		return this.presenter.getStoreScheduleTime(store, code, isAvailable);
	}

	onSelectStore(store: StoreModel, code: StoreDeliveryCodeEnum): void {
		this.storeSelected.emit({ store, code, slug: store.slug });
	}
}
